import { render, staticRenderFns } from "./labelValue.vue?vue&type=template&id=61c5b0b0&scoped=true&"
import script from "./labelValue.vue?vue&type=script&lang=js&"
export * from "./labelValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c5b0b0",
  null
  
)

export default component.exports